import {Transerializable, GetterConfigArgs, stringOr} from '@eventops/athlinks-get-or'
import {checkStringEnum} from '.'

export enum DistanceUnit {
  FEET = 'ft',
  KILO_METERS = 'km',
  HECTA_METERS = '100m',
  HECTA_YARDS = '100yd',
  METERS = 'm',
  MILES = 'mi',
  YARDS = 'yd'
}

export interface IDistance {
  distanceInMeters: number,
  distanceUnit: DistanceUnit
}

export class Distance extends Transerializable implements IDistance {
  config: GetterConfigArgs = {
    optionalPartialConfig: {
      distanceUnit: {
        getter: stringOr,
        decorators: (unit: string) => {
          if (!unit) {
            return DistanceUnit.METERS
          }
          if (!checkStringEnum(DistanceUnit, unit)) {
            throw new Error(`Invalid distance unit: ${unit}`)
          }
          return unit
        }
      }
    }
  }
  distanceInMeters = -1
  distanceUnit = DistanceUnit.METERS
}